import Avatar from '~components/ui/avatar'

type VetAvatarProps = Readonly<{ vetThumbnail: string }>

export const VetAvatar = ({ vetThumbnail }: VetAvatarProps) => {
  return <Avatar size="64" uri={vetThumbnail} alt="vet-thumbnail" />
}

export default VetAvatar
